import api from './api';

export const configService = {
  // Obtener configuración de notificaciones
  async getNotificationConfig() {
    try {
      const response = await api.get('/api/config/notifications');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener configuración',
      };
    }
  },

  // Actualizar configuración de notificaciones
  async updateNotificationConfig(configData) {
    try {
      const response = await api.put('/api/config/notifications', configData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar configuración',
      };
    }
  },

  // Verificar y enviar notificaciones manualmente
  async checkNotifications() {
    try {
      const response = await api.post('/api/config/notifications/check');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar notificaciones',
      };
    }
  },
};
